import { Location } from "store/Slices/locationSlice";
import { RootState } from "store/store";

export const selectLocations = (state: RootState): Location[] =>
  state.locationSlice.locations;

export const selectStoreNb = (state: RootState): number =>
  state.warehousePlanSlice.warehousePlan.storeNb;
